import {InfiniteData} from '@tanstack/react-query';
import {useMemo} from 'react';
import {selectListAndRestData} from './selectListAndRestData';

/**
 * react-query infinite data 형태를 list와 나머지 데이터로 분리하여 리턴합니다.
 */
export function useSelectListAndRestData<
  Query extends {[index: string]: any},
  OperationKey extends string,
>(
  operationKey: OperationKey,
  infiniteData?: InfiniteData<Query>
): Query[OperationKey] | undefined {
  return useMemo(
    () => selectListAndRestData(operationKey, infiniteData),
    [infiniteData, operationKey]
  );
}
